import { render, staticRenderFns } from "./ActoConceptos.vue?vue&type=template&id=5cf871e6&scoped=true"
import script from "./ActoConceptos.vue?vue&type=script&lang=js"
export * from "./ActoConceptos.vue?vue&type=script&lang=js"
import style0 from "./ActoConceptos.vue?vue&type=style&index=0&id=5cf871e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf871e6",
  null
  
)

export default component.exports